import { useQuery, UseQueryResult } from "@tanstack/react-query";

import { useDomainServices } from "@/providers/DomainServices";

import { ChatToolDetailResponse } from "../ChatRecord";

export function getQueryKey(chatId?: string, toolUseId?: string) {
  if (chatId === undefined || toolUseId === undefined) {
    return ["chatToolDetails"];
  }

  return ["chatToolDetails", chatId, toolUseId];
}

export function useToolDetails(
  chatId: string | undefined,
  toolUseId: string | undefined,
): UseQueryResult<ChatToolDetailResponse, Error> {
  const { chatService } = useDomainServices();

  return useQuery<ChatToolDetailResponse, Error>({
    queryKey: getQueryKey(chatId, toolUseId),
    queryFn: ({ signal }) => {
      if (chatId === undefined || toolUseId === undefined) {
        return Promise.reject(new Error("Invalid chatId or toolUseId"));
      }

      return chatService.getToolDetails(chatId, toolUseId, {
        abortSignal: signal,
      });
    },
    enabled: false,
  });
}
